/**
 * @owner @Appboy/messaging-experience
 */

import { customAttributeRemoteLookupValidators } from "@schemas/remoteLookup/customAttributeRemoteLookupSchema";
import type {
  CustomAttributeRemoteLookupId,
  CustomAttributeRemoteLookupItem,
  CustomAttributeRemoteLookupFilters,
} from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const customAttributeProvider: RemoteLookupProvider<
  CustomAttributeRemoteLookupId,
  CustomAttributeRemoteLookupItem,
  CustomAttributeRemoteLookupFilters
> = {
  mapItemToId: (item) => item.indexed_name,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: customAttributeRemoteLookupValidators,
};
